var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonItem',{attrs:{"title":_vm.textField,"img-url":_vm.iconUrl,"show-checkbox":_vm.showCheckbox}})}
var staticRenderFns = []

export { render, staticRenderFns }